import React from 'react';
import { Box } from "@mui/system";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";

const persianKeys = {
    weight: "وزن",
    min_commodity_ratio: "حداقل نسبت محصول",
    duration: "بازه زمانی",
}

const RecommendedSettingConfigs = ({ data, onInputChange }) => {

    const durationOptions = [7, 30, 90, 180, 365];

    const toolTipMessage = (key) => {
        switch (key) {
            case "weight":
                return "اعداد صحیح مثبت";
            case "min_commodity_ratio":
                return "بازه 0 تا 100";
            case "duration":
                return "روز";
            default:
                return "";
        }
    }

    return (
        Object.entries(data).map(([key, value], index) => {
            if (!persianKeys[key]) return null;

            return (

                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                            alignItems: "center",
                        }}
                    >
                        <Tooltip title={toolTipMessage(key)}>
                            <ErrorOutlineIcon sx={{ color: COLORS.GRAY }} />
                        </Tooltip>
                        <Typography>{persianKeys[key]}</Typography>
                    </Box>
                    {key === "duration" ? (
                        <Select
                            value={value}
                            onChange={(e) => onInputChange(key, +e.target.value)}
                            sx={{
                                width: "70px",
                                height: "46px",
                                textAlign: "center",
                                "& .MuiSelect-select": {
                                    textAlign: "center",
                                },
                            }}
                        >
                            {durationOptions.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    ) : (
                        <TextField
                            inputProps={{
                                style: { textAlign: "center", direction: "ltr" },
                            }}
                            sx={{
                                width: "70px",
                                height: "46px",
                            }}
                            variant="outlined"
                            type="number"
                            value={value}
                            onChange={(e) => onInputChange(key, +e.target.value)}
                        />
                    )}
                </Box>
            );
        })
    );
};

export default RecommendedSettingConfigs;